(ns com.theplantscape.plant-web.draw.canvas-actions
  (:require
   [com.theplantscape.plant-web.draw.events
    :as evt
    :refer [create-shape-multi-point move-ob select-ob-from-point select-remove-ob]]
   [com.theplantscape.plant-web.draw.state :refer [app-state]]))

(defn complete [xy]
  (create-shape-multi-point (-> @app-state :mouse :tool) xy))

(defn action
  [action-type xy]
  (prn (str "action " xy))
  (prn action-type)
  (prn (:mode @app-state))
  (case action-type
    :update (move-ob xy)
    (case (:mode @app-state)
      :move (move-ob xy)
      :select (select-ob-from-point xy)
      :remove (select-remove-ob xy)
      :insert (create-shape-multi-point (-> @app-state :mouse :tool) xy)
      (select-ob-from-point xy))))


(comment 
  (move-ob [50 50]))
